import React from 'react';
import { ListRooms } from '../components';

export const Page: React.FC = () => <ListRooms />;
